export default __webpack_public_path__ + "static/media/incident_management_icon.fedd7389.svg";